import { getCategoryNAField } from 'legacy/lut/components/widgets/public/partner360/planning/helpers/getCategoryNAField'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import { updateSectionSettings } from 'legacy/lut/features/partner360/sectionSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { useFinSobDropSignature } from 'partner360/hooks/finSob/useFinSobDropSignature'

interface IUseFinSobParams {
  partnerId: string
  fYear: number
}

interface IOnChangeNotApplicableParams {
  isNotApplicable: 1 | 0
  categoryField: string
  isNeedDropCommitment?: boolean
}

export const useChangeNotApplicable = ({ partnerId, fYear }: IUseFinSobParams) => {
  const dispatch = useAppDispatch()

  const { dropFinSignature } = useFinSobDropSignature()

  const onChangeNotApplicable = useCallback(
    async ({
      isNotApplicable,
      categoryField,
      isNeedDropCommitment,
    }: IOnChangeNotApplicableParams) => {
      const categoryNAField = getCategoryNAField(categoryField)
      const settingsForUpdate = { [categoryNAField]: isNotApplicable }

      await dispatch(
        updateSectionSettings({
          sectionSettings: settingsForUpdate,
          flag: categoryNAField,
          state: isNotApplicable,
          controlName: 'Planning',
        })
      ).unwrap()

      if (isNeedDropCommitment) {
        await dropFinSignature()
      }
      await dispatch(requestRecalculateCompleteness({ partnerId, fYear })).unwrap()
    },
    [dispatch, dropFinSignature, fYear, partnerId]
  )

  return onChangeNotApplicable
}
